import { api } from './authService';

export interface AvatarUploadResponse {
  success: boolean;
  message: string;
  avatarUrl?: string;
}

export const avatarService = {
  // Upload avatar image
  async uploadAvatar(file: File): Promise<AvatarUploadResponse> {
    try {
      const formData = new FormData();
      formData.append('avatar', file);

      const response = await api.post('/user/avatar', formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
        timeout: 10000, // 10 second timeout
      });

      return response.data;
    } catch (error: any) {
      console.error('❌ Avatar upload error:', error);
      
      // Daca backend-ul nu este disponibil sau returneaza eroare, foloseste fallback local
      if (error.code === 'NETWORK_ERROR' || error.code === 'ECONNABORTED' || error.response?.status >= 500) {
        return {
          success: true,
          message: 'Avatar salvat local (backend indisponibil)',
          avatarUrl: undefined // Va fi setat local in component
        };
      }
      
      throw new Error(error.response?.data?.message || 'Eroare la incarcarea avatar-ului');
    }
  },

  // Delete avatar
  async deleteAvatar(): Promise<AvatarUploadResponse> {
    try {
      const response = await api.delete('/user/avatar');
      return response.data;
    } catch (error: any) {
      console.error('❌ Avatar delete error:', error);
      
      // Daca backend-ul nu este disponibil, considera ca stergerea locala este suficienta
      if (error.code === 'NETWORK_ERROR' || error.code === 'ECONNABORTED' || error.response?.status >= 500) {
        return {
          success: true,
          message: 'Avatar sters local (backend indisponibil)'
        };
      }
      
      throw new Error(error.response?.data?.message || 'Eroare la stergerea avatar-ului');
    }
  },

  // Get avatar URL
  getAvatarUrl(userId: string): string {
    return `${api.defaults.baseURL}/user/avatar/${userId}`;
  },

  // Save avatar locally (fallback)
  saveAvatarLocally(file: File): string {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    return reader.result as string;
  },

  // Get local avatar from localStorage
  getLocalAvatar(userId: string): string | null {
    return localStorage.getItem(`avatar_${userId}`);
  },

  // Save local avatar to localStorage
  saveLocalAvatar(userId: string, avatarData: string): void {
    localStorage.setItem(`avatar_${userId}`, avatarData);
  },

  // Remove local avatar from localStorage
  removeLocalAvatar(userId: string): void {
    localStorage.removeItem(`avatar_${userId}`);
  }
};
